var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('v-sheet',{staticClass:"px-6 py-2",staticStyle:{"border-radius":"24px"},attrs:{"color":_vm.wsLIGHTCARD}},[_c('h4',{staticClass:"font-weight-regular"},[_vm._v(_vm._s(_vm.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }